import React from "react";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import Validator from "../../../../helpers/validator";
import {errorMessages} from "../../../../helpers/errorMessage";
import {routingAddresses} from "../../../../helpers/routing";
import {withRouter, RouteComponentProps} from "react-router";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import Form from "../../../../common/components/shared/form/form";
import {Utils} from "../../../../helpers/utils";
import {DictionariesOwnedVehiclesModel} from "../../../models/dictionariesOwnedVehicles";
import {DictionariesOwnedVehiclesService} from "../../../services/dictionariesOwnedVehiclesService";

interface OwnedVehicleFormState {
    isSubmitButtonBlocked: boolean;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface OwnedVehicleFormProps extends RouteComponentProps {
    ownedVehicleData?: DictionariesOwnedVehiclesModel | null;
    isUpdate: boolean;
}

class OwnedVehicleForm extends React.Component <OwnedVehicleFormProps, OwnedVehicleFormState> {
    private licencePlate!: ValidatedValue<string>;
    private name!: ValidatedValue<string>;

    constructor(props: any) {
        super(props);

        const ownedVehicleValidators = [{
            name: "valueIsNotEmpty",
            fn: Validator.isNotEmpty,
            errorMessage: errorMessages.required
        }];

        this.licencePlate = new ValidatedValue("", ownedVehicleValidators);
        this.name = new ValidatedValue("", ownedVehicleValidators);

        this.state = {
            isSubmitButtonBlocked: false,
            response: undefined
        };
    }
    async componentDidMount() {
        this.setOwnedVehicleData();
    }

    render() {
        return (
            <Form
                renderError={this.renderErrors()}
                renderContent={this.renderContent()}
                isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                backAddress={routingAddresses.dictionaries.ownedVehicles.list}
                submit={this.submit.bind(this)}
            />
        );
    }

    protected renderErrors() {
        if(!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={this.getErrorMessage()}
                    translatedFields={{
                        licencePlate: i18n.t("dictionaries.ownedVehicles.httpErrors.licencePlate"),
                        name: i18n.t("dictionaries.ownedVehicles.httpErrors.name"),
                    }}
                    translatedFieldsForEmpty={{
                        licencePlate: i18n.t("dictionaries.ownedVehicles.httpErrors.licencePlateForEmpty"),
                        name: i18n.t("dictionaries.ownedVehicles.httpErrors.nameForEmpty"),
                    }}
                    object={i18n.t("dictionaries.ownedVehicles.httpErrors.object")}
                />
            );
        }
    }

    protected renderContent() {
        return (
            <>
                <TextInput label={i18n.t("dictionaries.ownedVehicles.headers.licencePlate")} validatedValue={this.licencePlate} testId="owned-vehicle-licence-plate"/>
                <TextInput label={i18n.t("dictionaries.ownedVehicles.headers.name")} validatedValue={this.name} testId="owned-vehicle-name"/>
            </>
        );
    }

    private getErrorMessage() {
        return this.props.isUpdate
            ? i18n.t("dictionaries.ownedVehicles.errors.modifyErrorSuffix")
            : i18n.t("dictionaries.ownedVehicles.errors.addErrorSuffix");
    }

    public get isValid() {
        this.licencePlate.validate();
        this.name.validate();

        return this.licencePlate.isValid && this.name.isValid;
    }

    private setOwnedVehicleData() {
        this.licencePlate.setValue(this.props.ownedVehicleData?.licencePlate || "");
        this.name.setValue(this.props.ownedVehicleData?.name || "");
    }

    private async submit() {
        this.setState({response: undefined});

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});
            await this.addOrModifyOwnedVehicle();
            this.setState({isSubmitButtonBlocked: false});

            if (Api.isSuccess(this.state.response)) {
                this.props.history.push(routingAddresses.dictionaries.ownedVehicles.list);
            }
        }
        Utils.scrollToFirstErrorMessage();
    }

    private async addOrModifyOwnedVehicle(){
        if (this.props.isUpdate && this.props.ownedVehicleData?.id) {
            this.setState({
                response: await DictionariesOwnedVehiclesService.modifyOwnedVehicle({
                    licencePlate: this.licencePlate.value.trim(),
                    name: this.name.value.trim()
                }, this.props.ownedVehicleData?.id)
            });
        } else {
            this.setState({
                response: await DictionariesOwnedVehiclesService.addOwnedVehicle({
                    licencePlate: this.licencePlate.value.trim(),
                    name: this.name.value.trim(),
                })
            });
        }
    }
}

export default withRouter(OwnedVehicleForm);
